import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { UserOutlined } from '@ant-design/icons'
import { type MenuProps, Button, Divider, Dropdown, Space, theme } from 'antd'
import routes from 'routes/routes'
import { useAuth } from 'store/authStore/authStore'

import Avatar from 'components/atoms/Avatar/Avatar'

import { StyledLink, UserInfo } from './NavUserInfo.styles'

const { useToken } = theme

const NavUserInfo: FC = () => {
    const [{ user }, { logOut }] = useAuth()
    const { t } = useTranslation()
    const { token } = useToken()

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <StyledLink to={routes.user}>
                    {`${user.name} ${user?.surname ? user.surname : ''}`}
                </StyledLink>
            ),
            icon: <UserOutlined />,
        },
        {
            key: '2',
            label: (
                <StyledLink to={routes.aboutLogin}>
                    {t('about_login')}
                </StyledLink>
            ),
        },
    ]

    const contentStyle: React.CSSProperties = {
        backgroundColor: token.colorBgElevated,
        borderRadius: token.borderRadiusLG,
        boxShadow: token.boxShadowSecondary,
    }

    const menuStyle: React.CSSProperties = {
        boxShadow: 'none',
    }

    return (
        <Dropdown
            menu={{ items }}
            dropdownRender={(menu) => (
                <div style={contentStyle}>
                    {React.cloneElement(menu as React.ReactElement, {
                        style: menuStyle,
                    })}
                    <Divider style={{ margin: 0 }} />
                    <Space style={{ padding: '10px 16px' }}>
                        <Button type="primary" onClick={logOut}>
                            {t('log_out')}
                        </Button>
                    </Space>
                </div>
            )}
        >
            <UserInfo>
                <span>
                    {user.name} {user.surname}
                </span>
                <Avatar login={user.avatar} size={40} />
            </UserInfo>
        </Dropdown>
    )
}

export default NavUserInfo
